module.exports = __webpack_public_path__ + "img/img_quick_hrd.e33233de.jpg";